import classNames from "classnames";
import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
} from "@/components";
import type { ApiDeviceProfile } from "../../_types/device-profiles.types";
import { DotsVerticalIcon } from "@vetty/icons";
import styles from "./DeviceProfileListItem.module.scss";

const formatTime = (ms: number) =>
  new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(ms));

type DeviceProfileListItemProps = {
  profile: ApiDeviceProfile;
  onRowClick: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onRequestDelete: () => void;
  actionsDisabled: boolean;
};

export const DeviceProfileListItem = ({
  profile,
  onRowClick,
  onEdit,
  onDuplicate,
  onRequestDelete,
  actionsDisabled,
}: DeviceProfileListItemProps) => {
  return (
    <div className={styles["comp"]}>
      <button
        type="button"
        className={styles["comp__main"]}
        onClick={onRowClick}
        aria-label={`Open details for ${profile.name}`}
      >
        <div className={styles["comp__nameCell"]}>
          <span className={styles["comp__name"]}>{profile.name}</span>
          {profile.description ? (
            <span className={styles["comp__muted"]}>{profile.description}</span>
          ) : null}
        </div>
        <span className={styles["comp__version"]}>v{profile.configVersion}</span>
        <time className={styles["comp__updated"]} dateTime={new Date(profile.updatedAt).toISOString()}>
          {formatTime(profile.updatedAt)}
        </time>
      </button>

      <div className={styles["comp__actions"]}>
        <Dropdown>
          <DropdownTrigger className={styles["comp__dropdownTrigger"]}>
            <button
              type="button"
              className={styles["comp__menuTrigger"]}
              aria-label="Profile actions"
              aria-haspopup="menu"
              disabled={actionsDisabled}
            >
              <DotsVerticalIcon style={{ width: 20, height: 20 }} aria-hidden />
            </button>
          </DropdownTrigger>
          <DropdownContent width={180} lockBodyScroll={false}>
            <DropdownItem
              id={`${profile.id}-edit`}
              selectable={false}
              className={styles["comp__menuItem"]}
              disabled={actionsDisabled}
              onClick={() => onEdit()}
            >
              Edit
            </DropdownItem>
            <DropdownItem
              id={`${profile.id}-duplicate`}
              selectable={false}
              className={styles["comp__menuItem"]}
              disabled={actionsDisabled}
              onClick={() => onDuplicate()}
            >
              Duplicate
            </DropdownItem>
            <DropdownItem
              id={`${profile.id}-delete`}
              selectable={false}
              className={classNames(styles["comp__menuItem"], styles["comp__menuItem--danger"])}
              disabled={actionsDisabled}
              onClick={() => onRequestDelete()}
            >
              Delete
            </DropdownItem>
          </DropdownContent>
        </Dropdown>
      </div>
    </div>
  );
};
